import { Skeleton } from "@/components/ui/skeleton"

export function CategoriesSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <Skeleton className="h-8 w-32" />
        <Skeleton className="h-4 w-48" />
      </div>

      {/* Categories Grid */}
      <div className="grid gap-6 md:grid-cols-2">
        {Array.from({ length: 2 }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton structure
            key={`skeleton-category-${i}`}
            className="rounded-xl border shadow-sm"
          >
            <div className="p-6 space-y-2 border-b">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-4 w-48" />
            </div>
            <div className="p-6 space-y-4">
              <div className="space-y-2">
                {Array.from({ length: 4 }).map((_, j) => (
                  <div
                    // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton structure
                    key={`skeleton-category-item-${j}`}
                    className="flex items-center justify-between p-2 rounded-lg border"
                  >
                    <Skeleton className="h-6 w-24" />
                    <div className="flex gap-1">
                      <Skeleton className="h-8 w-8" />
                      <Skeleton className="h-8 w-8" />
                    </div>
                  </div>
                ))}
              </div>
              <Skeleton className="h-10 w-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
